import React, { useEffect, useState } from 'react';
import { Box, Fade } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Navbar from './Navbar';
import Footer from './Footer';

// Enhanced page transition container
const PageTransitionContainer = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  position: 'relative',
  overflow: 'hidden',
  
  // Page entrance animation
  '& .page-content': {
    animation: 'slideInUp 0.6s cubic-bezier(0.4, 0, 0.2, 1) forwards',
    opacity: 0,
    transform: 'translateY(20px)',
  },
  
  '@keyframes slideInUp': {
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    }
  },
  
  // Add subtle background texture for depth
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(135deg, rgba(255,255,255,0.02) 0%, rgba(0,0,0,0.01) 100%)',
    pointerEvents: 'none',
    zIndex: 0,
  }
}));

const AnimatedOutlet = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 1,
  minHeight: '100%',
  
  // Smooth content transitions
  '& > *': {
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  }
}));

const Layout = () => {
  const location = useLocation();
  const [fadeIn, setFadeIn] = useState(true);

  // Handle route changes with fade effect
  useEffect(() => {
    setFadeIn(false);
    const timer = setTimeout(() => {
      setFadeIn(true);
    }, 150);

    return () => clearTimeout(timer);
  }, [location.pathname]);
  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column',
      minHeight: '100vh',
      position: 'relative'
    }}>
      <Navbar />
      <PageTransitionContainer component="main">
        <Fade in={fadeIn} timeout={400}>
          <AnimatedOutlet className="page-content">
            <Outlet />
          </AnimatedOutlet>
        </Fade>
      </PageTransitionContainer>
      <Footer />
    </Box>
  );
};

export default Layout;
